import { render, staticRenderFns } from "./CopyableText.vue?vue&type=template&id=76ba8730&scoped=true"
import script from "./CopyableText.vue?vue&type=script&lang=js"
export * from "./CopyableText.vue?vue&type=script&lang=js"
import style0 from "./CopyableText.vue?vue&type=style&index=0&id=76ba8730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ba8730",
  null
  
)

export default component.exports